export type TurnstileErrorInfo = {
  code: string;
  message: string;
};

export enum ETurnstileErrorCode {
  ProtectionFailed = 'PROTECTION_FAILED',
  ProtectionExpired = 'PROTECTION_EXPIRED',
  Timeout = 'TIMEOUT',
  Unsupported = 'UNSUPPORTED',
}

export const TurnstileErrors: Record<ETurnstileErrorCode, TurnstileErrorInfo> = {
  [ETurnstileErrorCode.ProtectionFailed]: {
    code: ETurnstileErrorCode.ProtectionFailed,
    message:
      'We couldn’t verify that you’re not a bot. Try disabling tracking protection, reloading the page, or using a different browser.',
  },
  [ETurnstileErrorCode.ProtectionExpired]: {
    code: ETurnstileErrorCode.ProtectionExpired,
    message:
      'Your verification expired. Please verify again to continue.',
  },
  [ETurnstileErrorCode.Timeout]: {
    code: ETurnstileErrorCode.Timeout,
    message:
      'Verification timed out. Please refresh the page and try again.',
  },
  [ETurnstileErrorCode.Unsupported]: {
    code: ETurnstileErrorCode.Unsupported,
    message:
      'Your browser or device doesn’t support this verification. Please try again using a different browser.',
  },
};